"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmenityItem = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const Checkbox_1 = require("../input/checkbox/Checkbox");
const merlin_select_1 = require("@travelnest/merlin.select");
const Label_1 = require("../input/label/Label");
const helpers_1 = require("./helpers");
const Wrapper = styled_1.default.div `
	font-family: ${merlin_theme_1.default.typography.fonts.base};
	box-sizing: border-box;
	border-top: 1px solid ${merlin_theme_1.default.colours.neutral.light};
	padding: 20px 0;

	div:last-child {
		margin-right: 0;
	}
`;
const FlexWrapper = styled_1.default.div `
	color: ${merlin_theme_1.default.colours.neutral.black};
	display: flex;
	justify-content: space-between;
	align-items: center;
	${({ hasSubSelections }) => hasSubSelections && 'padding-bottom: 20px;'};

	label {
		padding: 0;
	}
`;
const CheckboxWrapper = styled_1.default.div `
	padding-left: 20px;
	border-left: 1px solid ${merlin_theme_1.default.colours.neutral.light};
`;
const AmenityItem = ({ amenity, onCheckboxClick, onOptionClick, }) => {
    const { name, selected, subSelections = [], subSelectionValue } = amenity;
    return (React.createElement(Wrapper, { "data-testid": `${name}-amenity-item` },
        React.createElement(FlexWrapper, { hasSubSelections: !!(selected && subSelections.length && subSelectionValue) },
            React.createElement(Label_1.Label, { htmlFor: `${name}-amenity-select` }, (0, helpers_1.amenityName)(name)),
            React.createElement(CheckboxWrapper, null,
                React.createElement(Checkbox_1.Checkbox, { name: name, onChange: (_, checked) => onCheckboxClick(Object.assign(Object.assign({}, amenity), { selected: checked })), checked: selected }))),
        selected && subSelections.length > 0 && subSelectionValue && (React.createElement(merlin_select_1.Select, { id: `${name}-amenity-select`, "data-testid": `${name}-amenity-select`, onChange: (event) => { var _a; return onOptionClick(Object.assign(Object.assign({}, amenity), { selected: true, subSelectionValue: (_a = subSelections.find(ss => ss.value === event.target.value)) === null || _a === void 0 ? void 0 : _a.value })); }, value: subSelectionValue }, subSelections === null || subSelections === void 0 ? void 0 : subSelections.map((sub) => React.createElement("option", { key: sub.value, value: sub.value }, sub.label))))));
};
exports.AmenityItem = AmenityItem;
//# sourceMappingURL=AmenityItem.js.map